import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import { formatMonto } from "@/utils";
import PerfilPerson from "@/components/functionals/employeePicture.vue";

const DiscountsColumns = [
  {
    prop: "Employee.FullName",
    label: "Empleado",
    "min-width": 100,
    formatter: PerfilPerson
  },
  {
    prop: "discount_Type",
    label: "Tipo de Ingreso",
    "min-width": 100
  },
  {
    prop: "discount_amount",
    label: "Monto",
    "min-width": 100,
    formatter: (row) => formatMonto(row.discount_amount)
  },
  {
    prop: "created_At",
    label: "Fecha de creacion",
    "min-width": 100,
    formatter: CellDateTime
  }
];

const DiscountsActions = [
  {
    label: "Editar Descuento",
    command: "edit_discount",
    icon: "el-icon-edit"
  },
  {
    label: "Borrar Descuento",
    command: "delete_discount",
    icon: "el-icon-delete"
  }
];

export { DiscountsColumns, DiscountsActions };
